<template>
<v-card
    max-width="280"
    shaped
    class="shapedto"
    elevation="3"
  >
    <v-list flat>
      <v-list-item-group v-model="model" color="primary">
        <v-list-item
          v-for="(item, i) in items"
          :key="i"
          :to="item.route"
        >
          <v-list-item-icon>
            <v-icon v-text="item.icon"></v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title v-text="item.text"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-card>
				
    
</template>

<script>
export default {
  data: () => ({
    items: [
        {
          icon: 'mdi-book',
          text: 'Présentation',
          route: '/qui-sommes-nous',
        },
        {
          icon: 'mdi-graph',
          text: 'Organigramme',
          route: '/Organigramme',
        },
        {
          icon: 'mdi-briefcase',
          text: 'Métiers',
          route: '/Metiers',
        },
        {
          icon: 'mdi-shield-star',
          text: 'Valeurs',
          route: '/Valeurs',
        },
        {
          icon: 'mdi-google-analytics',
          text: 'Chiffres clés',
          route: '/Chiffres-cles',
        },
      ],
      model: 1,
  })
    
}
</script>


<style scoped>


.shapedto {
  border-radius: 30px;
  
}


</style>